import { styled } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';

type StyledFooterLinksProps = {
  color?: string;
};

const StyledFooterLinks = styled(NavLink)<StyledFooterLinksProps>`
  &:link,
  &:visited,
  &:active {
    color: ${({ color }) => color || 'inherit'};
  }
  text-decoration: none;
`;

export default StyledFooterLinks;
